export default __webpack_public_path__ + "static/media/footerlogo.d6322771.png";